import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const getSections = (
  values: Record<string, any>,
  newPlanDetailsEnums: any,
  lineIdExternalCode: string
): IDynamicFormWidgetSection[] => {
  const isMotor = ['51', '50', '4'].includes(lineIdExternalCode);
  const showGRDetails = ['6', '19'].includes(lineIdExternalCode);
  const showSOSService = ['51', '4'].includes(lineIdExternalCode);
  const showReplacement = ['51'].includes(lineIdExternalCode);

  const sections: IDynamicFormWidgetSection[] = [
    {
      sectionTitle: 'General Details',
      inputs: {
        planName: {
          name: 'planName',
          title: 'Plan Name',
          type: FormFieldType.text,
          placeholder: 'Plan Name',
          value: values.planName,
          disabled: false,
          required: true,
        },
        externalCode: {
          name: 'externalCode',
          title: 'External Code',
          type: FormFieldType.text,
          placeholder: 'External Code',
          value: values.externalCode,
          disabled: false,
          required: true,
        },
        arabicName: {
          name: 'arabicName',
          title: 'Arabic Name',
          type: FormFieldType.text,
          placeholder: 'Arabic Name',
          value: values.arabicName,
          required: true,
          disabled: false,
        },
        abbreviation: {
          name: 'abbreviation',
          title: 'Abbreviation',
          type: FormFieldType.text,
          placeholder: 'Abbreviation',
          value: values.abbreviation,
          disabled: false,
          required: true,
        },
        effectiveFrom: {
          name: 'effectiveFrom',
          title: 'Effective From',
          type: FormFieldType.date,
          placeholder: 'Effective From',
          value: values.effectiveFrom,
          disabled: false,
          required: true,
        },
        effectiveTo: {
          name: 'effectiveTo',
          title: 'Effective To',
          type: FormFieldType.date,
          placeholder: 'Effective To',
          value: values.effectiveTo,
          required: true,
          disabled: false,
          minDate: new Date(values.effectiveFrom),
        },
        planCurrency: {
          name: 'planCurrency',
          title: 'Plan Currency',
          type: FormFieldType.select,
          placeholder: 'Plan Currency',
          value: !isEmpty(values.planCurrency) ? values.planCurrency : '',
          disabled: false,
          required: true,
          injectGlobalLov: {
            type: 'currency',
            value: 'Id',
            display: 'Title',
          },
        },
        maxNumberofInsured: {
          name: 'maxNumberofInsured',
          title: 'Max Number of Insured',
          type: FormFieldType.number,
          placeholder: 'Max Number of Insured',
          value: values.maxNumberofInsured,
          disabled: false,
          required: true,
          minValue: 0,
        },
        maxNumberofBeneficiary: {
          name: 'maxNumberofBeneficiary',
          title: 'Max Number of Beneficiary',
          type: FormFieldType.number,
          placeholder: 'Max Number of Beneficiary',
          value: values.maxNumberofBeneficiary,
          required: !isMotor,
          hidden: isMotor,
          disabled: isMotor,
          minValue: 0,
        },
        clauseEditable: {
          name: 'clauseEditable',
          title: 'Clause Editable',
          placeholder: 'Clause Editable',
          type: FormFieldType.switch,
          value: values.clauseEditable,
          required: true,
        },
      },
    },
  ];

  if (values && (showGRDetails || isMotor)) {
    sections.push({
      sectionTitle: 'Additional Details',
      inputs: {
        acalCategory: {
          name: 'acalCategory',
          title: 'Acal Category',
          type: FormFieldType.select,
          placeholder: 'Acal Category',
          value: !isEmpty(values.acalCategory) ? values.acalCategory : '',
          required: isMotor,
          disabled: !isMotor,
          hidden: !isMotor,
          selectOptions: newPlanDetailsEnums['acalCategory'],
        },
        scratching: {
          name: 'scratching',
          title: 'Scratching',
          type: FormFieldType.select,
          placeholder: 'Scratching',
          value: !isEmpty(values.scratching) ? values.scratching : '',
          required: isMotor,
          disabled: !isMotor,
          hidden: !isMotor,
          selectOptions: newPlanDetailsEnums['ScratchingOptions'],
        },
        sOSService: {
          name: 'sOSService',
          title: 'SOS Service',
          type: FormFieldType.select,
          placeholder: 'SOS Service',
          value: !isEmpty(values.sOSService) ? values.sOSService : '',
          required: showSOSService,
          disabled: !showSOSService,
          hidden: !showSOSService,
          selectOptions: newPlanDetailsEnums['sOSService'],
        },
        replacementCarApplied: {
          name: 'replacementCarApplied',
          title: 'Replacement Car Applied',
          type: FormFieldType.select,
          placeholder: 'Replacement Car Applied',
          value: !isEmpty(values.replacementCarApplied)
            ? values.replacementCarApplied
            : '',
          required: showReplacement,
          disabled: !showReplacement,
          hidden: !showReplacement,
          selectOptions: newPlanDetailsEnums['sOSService'],
        },
        replacementCarValue: {
          name: 'replacementCarValue',
          title: 'Replacement Car Value',
          type: FormFieldType.number,
          placeholder: 'Replacement Car Value',
          value: values.replacementCarValue,
          required: showReplacement,
          disabled: !showReplacement,
          hidden: !showReplacement,
        },
        replacementCarDays: {
          name: 'replacementCarDays',
          title: 'Replacement Car Days',
          type: FormFieldType.number,
          placeholder: 'Replacement Car Days',
          value: values.replacementCarDays,
          required: showReplacement,
          disabled: !showReplacement,
          hidden: !showReplacement,
        },
        grLimitDetails: {
          name: 'grLimitDetails',
          title: 'GR Limit Days',
          type: FormFieldType.number,
          placeholder: 'GR Limit Days',
          value: values.grLimitDetails,
          required: showGRDetails,
          hidden: !showGRDetails,
          disabled: !showGRDetails,
          minValue: 0,
        },
      },
    });
  }

  return sections;
};
